export default __webpack_public_path__ + "static/media/phone.a78b93dd.svg";